// extracted by mini-css-extract-plugin
export default {"wrapper":"PercentageStatDisplay_wrapper__LrZbz","value":"PercentageStatDisplay_value__CdUNO","strip":"PercentageStatDisplay_strip__SVr-X"};